














import { Vue, Component } from "vue-property-decorator";

// Enums/Data
import { ActionTypes } from "@/data/enums";
import PromotionProvider from "@/components/app/admin/catalogue/promotions/promotionProvider.vue";
import AddEditPromotion from "@/components/app/admin/catalogue/promotions/addEditPromotion.vue";

@Component({
  components: {
    PromotionProvider,
    AddEditPromotion
  }
})
export default class PromotionConfigurationView extends Vue {
  public $refs!: {
    addEditPromotion: AddEditPromotion;
  };
  public actionType: ActionTypes = ActionTypes.UPDATE;
  public isReloading = false;
  public async reloadData(reloadData: () => Promise<void>) {
    try {
      this.isReloading = true;
      await reloadData();
      this.$refs?.addEditPromotion.refreshForm();
    } finally {
      this.isReloading = false;
    }
  }
}
